import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';

function main() {
    const root = ReactDOM.createRoot(document.getElementById("root")!);
    root.render(React.createElement(App));
}

main();